import React from "react";
import { UserAuth } from "../../context/authContext";
import { clsx } from "clsx";
import { FiX, FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import logo from "../assets/astra_hack_logo.png";

export default function Sidebar({ user, onSidebarHide, showSidebar, items, selected, onSelect }) {
  const { logout } = UserAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <aside
      className={clsx(
        "fixed inset-y-0 left-0 z-30 w-64 glass-panel transform transition-transform duration-300 ease-in-out sm:translate-x-0 flex flex-col",
        showSidebar ? "translate-x-0" : "-translate-x-full"
      )}
    >
      <div className="flex items-center justify-between p-6 h-20 border-b border-white/5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-primary to-secondary p-[2px]">
            <div className="w-full h-full rounded-full bg-background overflow-hidden relative">
              {/* Use a placeholder if logo is missing to preventing broken images */}
              {logo ? (
                <img src={logo} alt="Logo" className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full bg-surface flex items-center justify-center text-xs font-bold">
                  Logo
                </div>
              )}
            </div>
          </div>
          <span className="font-bold text-xl tracking-wide">AstraHack</span>
        </div>
        <button
          onClick={onSidebarHide}
          className="sm:hidden text-text-muted hover:text-white transition-colors"
        >
          <FiX size={24} />
        </button>
      </div>

      <div className="flex-grow py-6 px-3 space-y-2 overflow-y-auto">
        {items.map((item) => (
          <MenuItem key={item.id} item={item} onClick={onSelect} selected={selected} />
        ))}
      </div>

      <div className="p-4 border-t border-white/5">
        {user && user.referralCode && (
          <div className="mb-4 p-3 bg-white/5 rounded-xl border border-white/5">
            <p className="text-xs text-text-muted mb-1 font-semibold uppercase">Referral Code</p>
            <div className="flex items-center justify-between gap-2">
              <code className="text-sm font-mono text-primary">{user.referralCode}</code>
              <button
                onClick={() => navigator.clipboard.writeText(user.referralCode)}
                className="text-text-muted hover:text-white text-xs"
              >
                Copy
              </button>
            </div>
          </div>
        )}

        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full px-4 py-3 text-text-muted hover:text-red-400 hover:bg-white/5 rounded-xl transition-all duration-200 group"
        >
          <FiLogOut className="group-hover:-translate-x-1 transition-transform" />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </aside>
  );
}

function MenuItem({ item: { id, title, Icon, notifications, link }, onClick, selected }) {
  const navigate = useNavigate();
  const handleClick = () => {
    if (link) {
      navigate(link);
    } else {
      onClick(id);
    }
  };
  return (
    <button
      onClick={handleClick}
      className={clsx(
        "flex items-center gap-3 w-full px-4 py-3 rounded-xl transition-all duration-200 relative",
        selected === id
          ? "bg-primary/20 text-primary shadow-[0_0_15px_rgba(249,104,240,0.3)]"
          : "text-text-muted hover:bg-white/5 hover:text-white"
      )}
    >
      {Icon && <Icon size={20} />}
      <span className="font-medium text-left flex-1">{title}</span>
      {notifications && (
        <span className="flex items-center justify-center w-5 h-5 bg-pink-500 text-white text-xs rounded-full font-bold">
          {notifications}
        </span>
      )}
    </button>
  );
}
